export default __webpack_public_path__ + "static/media/how-5@2x.343fa34d.png";